import api from '@/http/api';
import { TypeActivite } from '@/models/TypeActivite';
import { Activite } from '@/models/Activite';
import { RootState } from '@/store/types';
import { Action, ActionTree } from 'vuex';
import { ACTIVITES_STORE as S, ActivitesState, FiltredActivite, FiltredType } from "./types";
import { utils } from '@/util';
import router from '@/router';
import { Etablissement } from '@/models/Etablissement';


import db from "@/db";

export const fetchActivites: Action<
    ActivitesState,
    RootState
> = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listActivite = [] as Array<Activite>;

        commit(S.SET_CURRENT_DATE, utils.getCurrentTimeNow().format("YYYY-MM-DD"));
        commit(S.SET_IS_DATE_DIFF, false);
        let currentEtabActiviteId = rootGetters.getCurrentEtablissement.getActivites().map((activite: Activite) => activite.getId()) as Array<number>;
        let activitesId = rootGetters.getCurrentUser.activities as Array<number>;
        activitesId = activitesId.filter((id: number) => currentEtabActiviteId.includes(id));
        activitesId.forEach((id: number) => {
            let activite = db.getActiviteFromId(id);
            if (typeof activite !== 'undefined' && activite)
                listActivite.push(activite);
        });
        commit(S.SET_ACTIVITES, listActivite);
        resolve("fetchActivites done");
    })
};

export const fetchTypesActivites: Action<
    ActivitesState,
    RootState
> = ({ commit }) => {
    return new Promise((resolve, reject) => {
        commit(S.SET_TYPES_ACTIVITES, db.listTypesActivites());
        resolve("fetchTypesActivites done")
    })
};

export const filtreActivites: Action<
    ActivitesState,
    RootState
> = ({ commit, getters }) => {
    return new Promise((resolve, reject) => {
        let hasPointageHeure = true
        let now = utils.getDateFromString(getters.getDate, "YYYY-MM-DD")

        if (now.format("YYYY-MM-DD") !== utils.getCurrentTimeNow().format("YYYY-MM-DD"))
            hasPointageHeure = false

        let filtredActivites: FiltredActivite[] = []
        getters.getTypesActivites.forEach((typeActivite: TypeActivite) => {
            let categorieExist: boolean = false
            filtredActivites.forEach((filtredActivites: FiltredActivite) => {
                if (filtredActivites.categorie === typeActivite.getCategorie_nom())
                    categorieExist = true
            });
            if (!categorieExist) {
                let types: FiltredType[] = []
                getters.getTypesActivites.forEach((typeActivite2: TypeActivite) => {
                    if (typeActivite.getCategorie_nom() === typeActivite2.getCategorie_nom()) {
                        let listActivite: Activite[] = []
                        getters.getActivites.forEach((activite: Activite) => {
                            if (activite.getType_id() === typeActivite2.getId()
                                && utils.getDateFromString(activite.getDate_debut(), "YYYY-MM-DD") <= now
                                && utils.getDateFromString(activite.getDate_fin(), "YYYY-MM-DD") >= now
                                && activite.getJours().toLowerCase().includes(now.format('dddd').slice(0, 2))
                               
                            )
                                listActivite.push(activite)
                        });
                        if (listActivite.length !== 0)
                            types.push({
                                intitule: typeActivite2.getIntitule(),
                                activites: listActivite,
                                visible: true
                            })
                    }
                })
                if (types.length !== 0)
                    filtredActivites.push({
                        categorie: typeActivite.getCategorie_nom(),
                        types: types,
                        visible: true
                    })
            }
        });
        commit(S.SET_FILTRED_ACTIVITES, filtredActivites);
        resolve("done")
    })
};
export const selectActivite: Action<
    ActivitesState,
    RootState
> = ({ commit }, activite: Activite) => {
    return new Promise((resolve, reject) => {
        console.log("selectctivite");
        commit(S.SET_CURRENT_ACTIVITE, activite);
        if (activite.getPointage() === "EN_HORAIRE")
            router.push("/pointages/heure").then(function () {
                resolve("selectctivite done");
            }).catch(function (e) {
                console.error(e)
            })
        else
            router.push("/pointages/temps").then(function () {
                resolve("selectctivite done");
            }).catch(function (e) {
                console.error(e)
            })
    })
};

export const setCurrentDate: Action<
    ActivitesState,
    RootState
> = ({ commit, dispatch }, newDate: string) => {
    return new Promise((resolve, reject) => {
        commit(S.SET_CURRENT_DATE, newDate);
        commit(S.SET_IS_DATE_DIFF, newDate !== utils.getCurrentTimeNow().format("YYYY-MM-DD"))
        dispatch("filtreActivites").then(() => {
            resolve("DateTime Done")
        }).catch((e) => {
            reject(e)
        })
    })
};

export const actions: ActionTree<ActivitesState, RootState> = {
    selectActivite,
    fetchActivites,
    fetchTypesActivites,
    filtreActivites,
    setCurrentDate
};